import { canUseDrawingTool } from "./drawingModel";

function finiteNumber(value) {
  return typeof value === "number" && Number.isFinite(value) ? value : null;
}

function timestampMs(value) {
  const parsed = Date.parse(value);
  return Number.isFinite(parsed) ? parsed : null;
}

function validCandles(candles) {
  return (Array.isArray(candles) ? candles : []).filter(
    (candle) => candle?.timestamp && timestampMs(candle.timestamp) !== null
  );
}

export function nearestCandleIndex(candles, timestamp) {
  const list = validCandles(candles);
  const target = timestampMs(timestamp);
  if (!list.length || target === null) return null;

  let nearestIndex = 0;
  let nearestDistance = Math.abs(timestampMs(list[0].timestamp) - target);
  for (let index = 1; index < list.length; index += 1) {
    const distance = Math.abs(timestampMs(list[index].timestamp) - target);
    if (distance < nearestDistance) {
      nearestDistance = distance;
      nearestIndex = index;
    }
  }
  return nearestIndex;
}

function shiftTimestamp(timestamp, candleShift, candles) {
  const list = validCandles(candles);
  const index = nearestCandleIndex(list, timestamp);
  if (index === null) return timestamp;
  const shiftedIndex = Math.min(list.length - 1, Math.max(0, index + candleShift));
  return list[shiftedIndex].timestamp;
}

export function translateDrawingPoints(drawing, dragOrigin, currentPoint, candles) {
  if (
    !drawing ||
    drawing.isLocked ||
    !canUseDrawingTool(drawing.toolId) ||
    !Array.isArray(drawing.points) ||
    drawing.points.length === 0
  ) {
    return drawing?.points || [];
  }

  const originPrice = finiteNumber(dragOrigin?.price);
  const currentPrice = finiteNumber(currentPoint?.price);
  const originIndex = nearestCandleIndex(candles, dragOrigin?.timestamp);
  const currentIndex = nearestCandleIndex(candles, currentPoint?.timestamp);
  const priceDelta =
    originPrice !== null && currentPrice !== null ? currentPrice - originPrice : 0;
  const candleShift =
    originIndex !== null && currentIndex !== null ? currentIndex - originIndex : 0;

  if (drawing.toolId === "horizontal-line") {
    return drawing.points.map((point) => ({
      ...point,
      price:
        finiteNumber(point.price) !== null ? finiteNumber(point.price) + priceDelta : point.price,
    }));
  }

  if (drawing.toolId === "vertical-line") {
    return drawing.points.map((point) => ({
      ...point,
      timestamp: shiftTimestamp(point.timestamp, candleShift, candles),
    }));
  }

  if (drawing.toolId === "trend-line") {
    return drawing.points.map((point) => ({
      ...point,
      timestamp: shiftTimestamp(point.timestamp, candleShift, candles),
      price:
        finiteNumber(point.price) !== null ? finiteNumber(point.price) + priceDelta : point.price,
    }));
  }

  return drawing.points.map((point) => ({ ...point }));
}
